import React from "react";
import Header from "../component/sharedComponents/header";
import FooterUser from "../component/sharedComponents/footer";
import CustomIntroSection from "../component/explainBuyPage/customIntroSection";
import { useTranslation } from "react-i18next";
import PackagingShipmentContainer from "../component/PackagingShipment/PackagingShipmentContainer";

const PackagingShipmentsBeforeShippingPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px]">
        <CustomIntroSection title={t("PackagingShipmentTitle100")} />
      </div>
      <PackagingShipmentContainer />
      <FooterUser />
    </div>
  );
};
export default PackagingShipmentsBeforeShippingPage;
